import { useQuery } from '@tanstack/react-query'
import { axiosGet } from 'Redux/axiosHelper'
import { OrganizationResp } from 'types/globalTypes'

const searchOrganization = async (params: { queryString: string }) => {
  const response = await axiosGet(`v1/search/organization-name`, params)
  return response.data
}

export const useSearchOrganization = (params: { queryString: string }) => {
  const organizationsList = useQuery<OrganizationResp[]>(
    ['organization-search-by-string'],
    () => searchOrganization(params),
    { enabled: false },
  )
  return organizationsList
}
